import {IGameFilterDefinition} from '../interfaces/game-filter-definition.interface';
import {GameInfo} from '../../games/game-info';
import {GameGroupFilter} from "./game-group.filter";
import {SubgroupNameFilter} from "./subgroup-name.filter";
import {ApplyGameFilterResult} from "../interfaces/game-filter-evaluator.interface";

export class AllRouletteFilter implements IGameFilterDefinition {

  public readonly id: string = 'all-roulette';

  applyFilter(gameInfo: GameInfo): ApplyGameFilterResult {
    if(ApplyGameFilterResult.IncludeGame === new GameGroupFilter('roulette', 'Roulette').applyFilter(gameInfo)
        || ApplyGameFilterResult.IncludeGame === new SubgroupNameFilter('live-roulette', 'roulette').applyFilter(gameInfo)) {
      return ApplyGameFilterResult.IncludeGame;
    }
    return ApplyGameFilterResult.ExcludeGame;
  }
}
